import ChinmayaMissionPage from "../components/pages/ChinmayaMission";

export default ChinmayaMissionPage;
